import { render, staticRenderFns } from "./EditContactModal.vue?vue&type=template&id=002d85b1&"
import script from "./EditContactModal.vue?vue&type=script&lang=js&"
export * from "./EditContactModal.vue?vue&type=script&lang=js&"
import style0 from "./EditContactModal.vue?vue&type=style&index=0&id=002d85b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports